var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHead = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 32,
    viewBox: "0 0 14 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 32C12.9613 32 11.9812 31.5185 11.3464 30.6963L1.41545 17.8333C0.581615 16.7533 0.581616 15.2467 1.41545 14.1667L11.3464 1.30372C11.9812 0.481508 12.9613 1.81654e-06 14 1.90735e-06L14 32Z",
    fill: "#071A24",
    fillOpacity: 0.08
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/head.8b8d8fbc9b22d7a1473d411f51f03fab.svg";